module.exports = __webpack_public_path__ + "static/media/workingmemory-words-9.f339684a.mp3";